export default __webpack_public_path__ + "static/close-5ffe3c39b464e80fdeff5bc0f035ce8a.svg";